export const SETTINGS = {
    BASE_URL: process.env.REACT_APP_BASE_URL, // Ensure this matches the variable name in your .env file
    BASE_API_V1: process.env.REACT_API_BASE_URL_V1, // Ensure this matches the variable name in your .env file
    BASE_API_V2: process.env.REACT_API_BASE_URL_V2, // Ensure this matches the variable name in your .env file
    APP_VERSION: process.env.APP_VERSION,
};
